import React, { CSSProperties, ReactNode } from "react";
import "./row.css";

interface RowProps {
    children?: ReactNode;
    style?:CSSProperties;
}

const Row:React.FC<RowProps> = ({ children, style }) => {
    return (
        <div className="dry-design-row" style={{...style}}>
            {children}
        </div>
    )
}

export default Row;